const constants = {
  whatsAppUrl: "https://wa.me/552138282002",
  whatsAppNumber: "(21) 3828-2002",
  discountRate: 0.4,
  iprommoSalesPartnerId: 222,
  termsOfServiceUrl:
    "https://res.cloudinary.com/energea/image/upload/v1656340153/energea/br-documents/Termos_de_Servic%CC%A7o_-_Energea_Brasil.pdf",
  privacyPolicyUrl:
    "https://res.cloudinary.com/energea/image/upload/v1654184154/energea/br-documents/Poli%CC%81tica_de_privacidade_-_Energea_BR_01.06.2022.pdf",
  googleAnalyticsId: "UA-154452745-1",
  linkedInUrl: "https://www.linkedin.com/company/energea-brasil/",
  facebookUrl: "https://www.facebook.com/energeabrasil",
  instagramUrl: "https://www.instagram.com/energea.brasil/",
  headerLogoUrl: `${process.env.PUBLIC_URL}/energea-logo-full.svg`,
  footerLogoUrl: `${process.env.PUBLIC_URL}/energea-logo-full.svg`,
  headerLogoWidth: "120px",
  footerLogoWidth: "100px",
  // howToVideoTag: 'dfwny22kjavvxhhuzdpx', // updated May 28th, 2020
  howToVideoTag: "cqqi4tv4frl4h1utpuop", // updated July 8th, 2020
  missingImagePublicId: "site/missing_image",
  missingImageUrl:
    "https://res.cloudinary.com/energea/image/upload/v1555681708/site/missing_image.webp",
  globalCompanyName: "Energea",
  brCustomerReferralProgram: {
    enabled: true,
    referralAmountBrl: 50,
    daysToExpiration: 365,
  },
  roles: [
    {
      label: "Owner",
      description: "Account owner can pay invoices, and manage users.",
      value: "owner",
    },
    {
      label: "Admin",
      description:
        "Account admins can view and pay invoices, but not manage users.",
      value: "admin",
    },
    {
      label: "Member",
      description:
        "Account members can view invoices, and performance, but access is read only.",
      value: "member",
    },
    {
      label: "Salesperson",
      description:
        "Account members can view invoices, and performance, but access is read only.",
      value: "salesPerson",
    },
  ],
};

const findWithAttr = (array, attr, value) => {
  if (!array || !attr || !value) return null;
  for (let i = 0; i < array.length; i += 1) {
    if (array[String(i)][String(attr)].toString() === value.toString()) {
      return array[String(i)];
    }
  }
  return null;
};

const getGradient = (context, color) => {
  const { chart } = context;
  const { ctx, chartArea } = chart;

  const clear = "rgba(255,255,255,0)";
  if (!chartArea) {
    return null;
  }
  const gradient = ctx.createLinearGradient(
    0,
    chartArea.top,
    0,
    chartArea.bottom,
  );
  gradient.addColorStop(0, color);
  // gradient.addColorStop(0.5, "rgba(255,255,255,.1)");
  gradient.addColorStop(1, clear);
  return gradient;
};

const lintAwsObjectKey = (str) => str?.normalize().replaceAll(",", "_");

const isCemigWattsHubV2EnabledForSalesPartner = (brSalesPersonId) => {
  return true;
};

const normalizeUtilityCompanyName = (utilityCompany) =>
  String(utilityCompany || "")
    .trim()
    .toLowerCase();

const getPowerPlanConfigFromBillAmount = (amount, utilityCompany) => {
  const billAmount = Number(amount || 0);
  const normalizedUtilityCompany = normalizeUtilityCompanyName(utilityCompany);

  if (!normalizedUtilityCompany) {
    return { brPowerPlanId: null, discountRate: 0 };
  }

  // NOTE: The discountRate key is used for frontend labels/logic, while the
  // brPowerPlanId determines the actual backend power plan selection.
  if (normalizedUtilityCompany === "light") {
    return { brPowerPlanId: 471, discountRate: 0.13 };
  }

  if (normalizedUtilityCompany === "cemig") {
    if (billAmount <= 1000) {
      return { brPowerPlanId: 541, discountRate: 0.26 };
    }
    if (billAmount <= 2000) {
      return { brPowerPlanId: 843, discountRate: 0.28 };
    }
    if (billAmount <= 5000) {
      return { brPowerPlanId: 483, discountRate: 0.3 };
    }
    if (billAmount <= 20000) {
      return { brPowerPlanId: 842, discountRate: 0.35 };
    }
    return { brPowerPlanId: 805, discountRate: 0.4 };
  }

  return { brPowerPlanId: null, discountRate: 0 };
};

const getEstimatedMonthlySavingsFromBillAmount = (amount, utilityCompany) =>
  Number(amount || 0) *
  getPowerPlanConfigFromBillAmount(amount, utilityCompany).discountRate;

export {
  lintAwsObjectKey,
  constants,
  findWithAttr,
  getGradient,
  getEstimatedMonthlySavingsFromBillAmount,
  getPowerPlanConfigFromBillAmount,
  isCemigWattsHubV2EnabledForSalesPartner,
};
